<template>
  <div>
    <b-overlay
        :show="(loading || selectLoading)"
        rounded="sm"
        no-fade
      >

    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      :start-index.sync="activeIndex"
      ref="form"
      layout="vertical"
      finish-button-text="Salvar"
      back-button-text="Voltar"
      next-button-text="Próximo"
      class="wizard-vertical mb-3"
      @on-complete="formSubmitted"
    >

        <!-- Usina -->
        <tab-content title="Usina">
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Usina
              </h5>
              <small class="text-muted">
                Edite a usina que pertence essas informações.
              </small>
            </b-col>

            <!-- Usina -->
            <b-col md="6">
              <b-form-group
                label="Usina"
                label-for="usina_id"
              >
                <v-select
                  id="usina_id"
                  v-model="usina_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="usinaName"
                  label="text"
                  placeholder="Selecione uma Usina"
                />
              </b-form-group>
            </b-col>

            <!-- ID -->
            <b-col cols="6">
              <b-form-group
                label="ID"
                label-for="id"
              >
                <b-form-input
                  id="id"
                  :value="id"
                  placeholder="ID"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- status_da_usina -->
            <b-col cols="6">
              <b-form-group
                label="Status da Usina"
                label-for="status_da_usina"
              >
                <v-select
                  id="status_da_usina"
                  v-model="status_da_usina"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="statusUsina"
                  label="text"
                  placeholder="Status da Usina"
                />
              </b-form-group>
            </b-col>

            <!-- recuperacao_falidas -->
            <b-col cols="6">
              <b-form-group
                label="Status Legal"
                label-for="recuperacao_falidas"
              >
                <v-select
                  id="recuperacao_falidas"
                  v-model="recuperacao_falidas"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="tipoRecuperacao"
                  label="text"
                  placeholder="Status Legal"
                />
              </b-form-group>
            </b-col>

            <!-- tipo_de_producao -->
            <b-col cols="6">
              <b-form-group
                label="Tipo de Produção"
                label-for="tipo_de_producao"
              >
                <v-select
                  id="tipo_de_producao"
                  v-model="tipo_de_producao"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="tipoProducao"
                  label="text"
                  placeholder="Tipo de Produção"
                />
              </b-form-group>
            </b-col>

            <!-- california_intensidade_carbono -->
            <b-col cols="6">
              <b-form-group
                label="Califórnia: Intensidade de Carbono"
                label-for="california_intensidade_carbono"
              >
                <b-form-input
                  id="california_intensidade_carbono"
                  :value="california_intensidade_carbono"
                  v-model="california_intensidade_carbono"
                  placeholder="Califórnia: Intensidade de Carbono"
                />
              </b-form-group>
            </b-col>

            <!-- dirigentes -->
            <b-col cols="12">
              <b-form-group
                label="Dirigentes"
                label-for="dirigentes"
              >
                <b-form-input
                  id="dirigentes"
                  :value="dirigentes"
                  v-model="dirigentes"
                  placeholder="Dirigentes"
                />
              </b-form-group>
            </b-col>

            <!-- materia_prima -->
            <b-col cols="6">
              <b-form-group
                label="Matéria-prima"
                label-for="materia_prima"
              >
                <b-form-input
                  id="materia_prima"
                  :value="materia_prima"
                  v-model="materia_prima"
                  placeholder="Matéria-prima"
                />
              </b-form-group>
            </b-col>

            <!-- producao_milho_milhoes_litros -->
            <b-col cols="6">
              <b-form-group
                label="Produção de Milho (Milhões de Litros)"
                label-for="producao_milho_milhoes_litros"
              >
                <b-form-input
                  id="producao_milho_milhoes_litros"
                  :value="producao_milho_milhoes_litros"
                  v-model="producao_milho_milhoes_litros"
                  placeholder="Produção de Milho (Milhões de Litros)"
                />
              </b-form-group>
            </b-col>

            <!-- producao_milho_mil_toneladas -->
            <b-col cols="6">
              <b-form-group
                label="Produção de Milho (Mil Toneladas)"
                label-for="producao_milho_mil_toneladas"
              >
                <b-form-input
                  id="producao_milho_mil_toneladas"
                  :value="producao_milho_mil_toneladas"
                  v-model="producao_milho_mil_toneladas"
                  placeholder="Produção de Milho (Mil Toneladas)"
                />
              </b-form-group>
            </b-col>

            <!-- ddg -->
            <b-col cols="6">
              <b-form-group
                label="DDG"
                label-for="ddg"
              >
                <b-form-input
                  id="ddg"
                  :value="ddg"
                  v-model="ddg"
                  placeholder="DDG"
                />
              </b-form-group>
            </b-col>

            <!-- oleo -->
            <b-col cols="6">
              <b-form-group
                label="Óleo"
                label-for="oleo"
              >
                <b-form-input
                  id="oleo"
                  :value="oleo"
                  v-model="oleo"
                  placeholder="Óleo"
                />
              </b-form-group>
            </b-col>

            <!-- combustivel_usado -->
            <b-col cols="6">
              <b-form-group
                label="Combustível Usado"
                label-for="combustivel_usado"
              >
                <b-form-input
                  id="combustivel_usado"
                  :value="combustivel_usado"
                  v-model="combustivel_usado"
                  placeholder="Combustível Usado"
                />
              </b-form-group>
            </b-col>

            <!-- tancagem -->
            <b-col cols="6">
              <b-form-group
                label="Tancagem"
                label-for="tancagem"
              >
                <b-form-input
                  id="tancagem"
                  :value="tancagem"
                  v-model="tancagem"
                  placeholder="Tancagem"
                />
              </b-form-group>
            </b-col>

            <!-- biogasBiometano -->
            <b-col cols="6">
              <b-form-group
                label="Biogas Biometano"
                label-for="biogasBiometano"
              >
                <b-form-input
                  id="biogasBiometano"
                  :value="biogasBiometano"
                  v-model="biogasBiometano"
                  placeholder="Biogas Biometano"
                />
              </b-form-group>
            </b-col>

            <!-- graficoCentroGravidade -->
            <b-col cols="6">
              <b-form-group
                label="Grafico Centro Gravidade"
                label-for="graficoCentroGravidade"
              >
                <b-form-input
                  id="graficoCentroGravidade"
                  :value="graficoCentroGravidade"
                  v-model="graficoCentroGravidade"
                  placeholder="Brafico Centro Gravidade"
                />
              </b-form-group>
            </b-col>

            </b-row>
          </tab-content>

          <!-- Capacidade -->
          <tab-content title="Capacidade">
            <b-row>

              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Capacidade de moagem
                </h5>
                <small class="text-muted">Edite a capacidade de moagem</small>
              </b-col>

              <!-- capacidade_moagem_ton_cana_dia -->
              <b-col cols="6">
                <b-form-group
                  label="Por dia"
                  label-for="capacidade_moagem_ton_cana_dia"
                >
                  <b-form-input
                    id="capacidade_moagem_ton_cana_dia"
                    :value="capacidade_moagem_ton_cana_dia"
                    v-model="capacidade_moagem_ton_cana_dia"
                    placeholder="Por dia"
                  />
                </b-form-group>
              </b-col>

              <!-- capacidade_moagem_ton_cana_hora -->
              <b-col cols="6">
                <b-form-group
                  label="Por hora"
                  label-for="capacidade_moagem_ton_cana_hora"
                >
                  <b-form-input
                    id="capacidade_moagem_ton_cana_hora"
                    :value="capacidade_moagem_ton_cana_hora"
                    v-model="capacidade_moagem_ton_cana_hora"
                    placeholder="Por hora"
                  />
                </b-form-group>
              </b-col>

              <!-- capacidade_moagem_ton_cana_safra -->
              <b-col cols="6">
                <b-form-group
                  label="Por safra"
                  label-for="capacidade_moagem_ton_cana_safra"
                >
                  <b-form-input
                    id="capacidade_moagem_ton_cana_safra"
                    :value="capacidade_moagem_ton_cana_safra"
                    v-model="capacidade_moagem_ton_cana_safra"
                    placeholder="Por safra"
                  />
                </b-form-group>
              </b-col>

              <!-- se_a_moagem_foi_calculada -->
              <b-col cols="6">
                <b-form-group
                  label="Moagem foi calculada?"
                  label-for="se_a_moagem_foi_calculada"
                >
                  <v-select
                    id="se_a_moagem_foi_calculada"
                    v-model="se_a_moagem_foi_calculada"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="moagemCalculadaName"
                    label="text"
                    placeholder="Selecione uma Opção"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group
                  label="Rank Moagem"
                  label-for="rank_moagem"
                >
                  <b-form-input
                    id="rank_moagem"
                    :value="rank_moagem"
                    v-model="rank_moagem"
                    placeholder="Rank Moagem"
                    disabled
                  />
                </b-form-group>
              </b-col>

          </b-row>

          <b-row>
            <b-col cols="12">
              <hr>
            </b-col>
          
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Capacidade de etanol
              </h5>
              <small class="text-muted">Edite a capacidade de etanol</small>
            </b-col>

            <b-col cols="6">
              <b-form-group
                label="Produção Anidro"
                label-for="capacidade_producao_etanol_anidro"
              >
                <b-form-input
                  id="capacidade_producao_etanol_anidro"
                  :value="capacidade_producao_etanol_anidro"
                  v-model="capacidade_producao_etanol_anidro"
                  placeholder="Produção Anidro"
                />
              </b-form-group>
            </b-col>

            <b-col cols="6">
              <b-form-group
                label="Rank Anidro"
                label-for="rank_anidro"
              >
                <b-form-input
                  id="rank_anidro"
                  :value="rank_anidro"
                  v-model="rank_anidro"
                  placeholder="Rank Anidro"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- capacidade_producao_etanol_hidratado -->
            <b-col cols="6">
              <b-form-group
                label="Produção Hidratado"
                label-for="capacidade_producao_etanol_hidratado"
              >
                <b-form-input
                  id="capacidade_producao_etanol_hidratado"
                  :value="capacidade_producao_etanol_hidratado"
                  v-model="capacidade_producao_etanol_hidratado"
                  placeholder="Produção Hidratado"
                />
              </b-form-group>
            </b-col>

            <b-col cols="6">
              <b-form-group
                label="Rank Hidratado"
                label-for="rank_hidratado"
              >
                <b-form-input
                  id="rank_hidratado"
                  :value="rank_hidratado"
                  v-model="rank_hidratado"
                  placeholder="Rank Hidratado"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- capacidade_producao_etanol_total -->
            <b-col cols="6">
              <b-form-group
                label="Produção Total"
                label-for="capacidade_producao_etanol_total"
              >
                <b-form-input
                  id="capacidade_producao_etanol_total"
                  :value="capacidade_producao_etanol_total"
                  v-model="capacidade_producao_etanol_total"
                  placeholder="Produção Total"
                />
              </b-form-group>
            </b-col>

            <b-col cols="6">
              <b-form-group
                label="Rank Etanol"
                label-for="rank_etanol"
              >
                <b-form-input
                  id="rank_etanol"
                  :value="rank_etanol"
                  v-model="rank_etanol"
                  placeholder="Rank Etanol"
                  disabled
                />
              </b-form-group>
            </b-col>

          </b-row>

          <b-row>
            <b-col cols="12">
              <hr>
            </b-col>
          
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Capacidade de açúcar
              </h5>
              <small class="text-muted">Edite a capacidade de produção de açúcar</small>
            </b-col>

            <!-- producao_acucar_sacas_dia -->
            <b-col cols="6">
              <b-form-group
                label="Sacas por dia"
                label-for="producao_acucar_sacas_dia"
              >
                <b-form-input
                  id="producao_acucar_sacas_dia"
                  :value="producao_acucar_sacas_dia"
                  v-model="producao_acucar_sacas_dia"
                  placeholder="Sacas por dia"
                />
              </b-form-group>
            </b-col>

            <!-- producao_acucar_ranking_sacas_dia -->
            <b-col cols="6">
              <b-form-group
                label="Ranking em sacas por dia"
                label-for="producao_acucar_ranking_sacas_dia"
              >
                <b-form-input
                  id="producao_acucar_ranking_sacas_dia"
                  :value="producao_acucar_ranking_sacas_dia"
                  v-model="producao_acucar_ranking_sacas_dia"
                  placeholder="Ranking em sacas por dia"
                  disabled
                />
              </b-form-group>
            </b-col>

            <!-- producao_acucar_ton_safra -->
            <b-col cols="6">
              <b-form-group
                label="Safra em toneladas"
                label-for="producao_acucar_ton_safra"
              >
                <b-form-input
                  id="producao_acucar_ton_safra"
                  :value="producao_acucar_ton_safra"
                  v-model="producao_acucar_ton_safra"
                  placeholder="Safra em toneladas"
                />
              </b-form-group>
            </b-col>

            <!-- producao_acucar_ranking_ton_safra -->
            <b-col cols="6">
              <b-form-group
                label="Ranking em safra em toneladas"
                label-for="producao_acucar_ranking_ton_safra"
              >
                <b-form-input
                  id="producao_acucar_ranking_ton_safra"
                  :value="producao_acucar_ranking_ton_safra"
                  v-model="producao_acucar_ranking_ton_safra"
                  placeholder="Ranking em safra em toneladas"
                  disabled
                />
              </b-form-group>
            </b-col>

          </b-row>
                  
      </tab-content>

      <!-- Bioeletricidade -->
      <tab-content title="Bioeletricidade">
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Potência
              </h5>
              <small class="text-muted">Edite a potência</small>
            </b-col>

            <!-- potencia_instalada -->
            <b-col cols="6">
              <b-form-group
                label="Potência Fiscalizada"
                label-for="potencia_instalada"
              >
                <b-form-input
                  id="potencia_instalada"
                  :value="potencia_instalada"
                  v-model="potencia_instalada"
                  placeholder="Potência Fiscalizada"
                />
              </b-form-group>
            </b-col>

            <!-- garantia_fisica -->
            <b-col cols="6">
              <b-form-group
                label="Garantia Física"
                label-for="garantia_fisica"
              >
                <b-form-input
                  id="garantia_fisica"
                  :value="garantia_fisica"
                  v-model="garantia_fisica"
                  placeholder="Garantia Física"
                />
              </b-form-group>
            </b-col>

            <b-col cols="6">
              <b-form-group
                label="Rank Energia"
                label-for="rank_energia"
              >
                <b-form-input
                  id="rank_energia"
                  :value="rank_energia"
                  v-model="rank_energia"
                  placeholder="Rank Energia"
                  disabled
                />
              </b-form-group>
            </b-col>

          </b-row>

          <b-row>
            <b-col cols="12">
              <hr>
            </b-col>
          
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Cogeração
              </h5>
              <small class="text-muted">Edite a Cogeração</small>
            </b-col>
          </b-row>

          <!-- Cogeração -->
          <b-row
            v-for="(item, index) in destino_proprietario_cogeracao"
            :id="index"
            :key="'cog_'+index"
            ref="row"
          >

          <!-- cogeracao_nome -->
          <b-col cols="6">
            <b-form-group
              label="Nome"
              label-for="cogeracao_nome"
            >
              <b-form-input
                id="cogeracao_nome"
                placeholder="Nome"
                :value="item.nome"
                v-model="item.nome"
              />
            </b-form-group>
          </b-col>

          <!-- cogeracao_destino -->
          <b-col cols="6">
            <b-form-group
              label="Destino"
              label-for="cogeracao_destino"
            >
              <b-form-input
                id="cogeracao_destino"
                placeholder="Destino"
                :value="item.destino"
                v-model="item.destino"
              />
            </b-form-group>
          </b-col>

          <!-- cogeracao_valores -->
          <b-col cols="6">
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label="Empresa"
                  label-for="cogeracao_empresa"
                >
                  <b-form-input
                    id="cogeracao_empresa"
                    placeholder="Empresa"
                    :value="item.empresa"
                    v-model="item.empresa"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label="Participação"
                  label-for="cogeracao_participacao"
                >
                  <b-form-input
                    id="cogeracao_participacao"
                    placeholder="Participação"
                    :value="item.participacao"
                    v-model="item.participacao"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <!-- cogeracao_potencia -->
          <b-col cols="6">
            <b-form-group
              label="Potência"
              label-for="cogeracao_potencia"
            >
              <b-form-input
                id="cogeracao_potencia"
                placeholder="Potência"
                :value="item.potencia"
                v-model="item.potencia"
              />
            </b-form-group>
          </b-col>

          <!-- Remove Button -->
          <b-col
            lg="2"
            md="3"
            class="mb-50"
          >
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              class="mt-0 mt-md-2"
              size="sm"
              @click="removeItem(index)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>Deletar</span>
            </b-button>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>

        </b-row>

        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="success"
          size="sm"
          @click="addItem"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-25"
          />
          <span>Adicionar</span>
        </b-button>

        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Geração no centro de atividade das usinas
            </h5>
            <small class="text-muted">Edite a geração no centro de atividade das usinas</small>
          </b-col>
        </b-row>

        <!-- geracao_centro_gravidade -->
        <b-row
          v-for="(item, index) in geracao_centro_gravidade"
          :id="index"
          :key="index"
          ref="rowGrav"
        >

          <!-- centro_gravidade_ano -->
          <b-col cols="12">
            <b-form-group
              label="Ano"
              label-for="centro_gravidade_ano"
            >
              <b-form-input
                id="centro_gravidade_ano"
                placeholder="Ano"
                :value="item['ano'] ? item['ano'] : 0"
                v-model="item['ano']"
              />
            </b-form-group>
          </b-col>

          <!-- centro_gravidade_janeiro -->
          <b-col cols="3">
            <b-form-group
              label="Janeiro"
              label-for="centro_gravidade_janeiro"
            >
              <b-form-input
                id="centro_gravidade_janeiro"
                placeholder="Janeiro"
                :value="item['Janeiro'] ? item['Janeiro'] : 0"
                v-model="item['Janeiro']"
              />
            </b-form-group>
          </b-col>

          <!-- centro_gravidade_fevereiro -->
          <b-col cols="3">
            <b-form-group
              label="Fevereiro"
              label-for="centro_gravidade_fevereiro"
            >
              <b-form-input
                id="centro_gravidade_fevereiro"
                placeholder="Fevereiro"
                :value="item['Fevereiro'] ? item['Fevereiro'] : 0"
                v-model="item['Fevereiro']"
              />
            </b-form-group>
          </b-col>

          <!-- centro_gravidade_marco -->
          <b-col cols="3">
            <b-form-group
              label="Março"
              label-for="centro_gravidade_marco"
            >
              <b-form-input
                id="centro_gravidade_marco"
                placeholder="Março"
                :value="item['Março'] ? item['Março'] : 0"
                v-model="item['Março']"
              />
            </b-form-group>
          </b-col>

          <!-- centro_gravidade_abril -->
          <b-col cols="3">
            <b-form-group
              label="Abril"
              label-for="centro_gravidade_abril"
            >
              <b-form-input
                id="centro_gravidade_abril"
                placeholder="Abril"
                :value="item['Abril'] ? item['Abril'] : 0"
                v-model="item['Abril']"
              />
            </b-form-group>
          </b-col>

          <!-- centro_gravidade_maio -->
          <b-col cols="3">
            <b-form-group
              label="Maio"
              label-for="centro_gravidade_maio"
            >
              <b-form-input
                id="centro_gravidade_maio"
                placeholder="Maio"
                :value="item['Maio'] ? item['Maio'] : 0"
                v-model="item['Maio']"
              />
            </b-form-group>
          </b-col>

          <!-- centro_gravidade_junho -->
          <b-col cols="3">
            <b-form-group
              label="Junho"
              label-for="centro_gravidade_junho"
            >
              <b-form-input
                id="centro_gravidade_junho"
                placeholder="Junho"
                :value="item['Junho'] ? item['Junho'] : 0"
                v-model="item['Junho']"
              />
            </b-form-group>
          </b-col>

          <!-- centro_gravidade_julho -->
          <b-col cols="3">
            <b-form-group
              label="Julho"
              label-for="centro_gravidade_julho"
            >
              <b-form-input
                id="centro_gravidade_julho"
                placeholder="Julho"
                :value="item['Julho'] ? item['Julho'] : 0"
                v-model="item['Julho']"
              />
            </b-form-group>
          </b-col>

          <!-- centro_gravidade_agosto -->
          <b-col cols="3">
            <b-form-group
              label="Agosto"
              label-for="centro_gravidade_agosto"
            >
              <b-form-input
                id="centro_gravidade_agosto"
                placeholder="Agosto"
                :value="item['Agosto'] ? item['Agosto'] : 0"
                v-model="item['Agosto']"
              />
            </b-form-group>
          </b-col>

          <!-- centro_gravidade_setembro -->
          <b-col cols="3">
            <b-form-group
              label="Setembro"
              label-for="centro_gravidade_setembro"
            >
              <b-form-input
                id="centro_gravidade_setembro"
                placeholder="Setembro"
                :value="item['Setembro'] ? item['Setembro'] : 0"
                v-model="item['Setembro']"
              />
            </b-form-group>
          </b-col>

          <!-- centro_gravidade_outubro -->
          <b-col cols="3">
            <b-form-group
              label="Outubro"
              label-for="centro_gravidade_outubro"
            >
              <b-form-input
                id="centro_gravidade_outubro"
                placeholder="Outubro"
                :value="item['Outubro'] ? item['Outubro'] : 0"
                v-model="item['Outubro']"
              />
            </b-form-group>
          </b-col>

          <!-- centro_gravidade_novembro -->
          <b-col cols="3">
            <b-form-group
              label="Novembro"
              label-for="centro_gravidade_novembro"
            >
              <b-form-input
                id="centro_gravidade_novembro"
                placeholder="Novembro"
                :value="item['Novembro'] ? item['Novembro'] : 0"
                v-model="item['Novembro']"
              />
            </b-form-group>
          </b-col>

          <!-- centro_gravidade_dezembro -->
          <b-col cols="3">
            <b-form-group
              label="Dezembro"
              label-for="centro_gravidade_dezembro"
            >
              <b-form-input
                id="centro_gravidade_dezembro"
                placeholder="Dezembro"
                :value="item['Dezembro'] ? item['Dezembro'] : 0"
                v-model="item['Dezembro']"
              />
            </b-form-group>
          </b-col>

          <!-- Remove Button -->
          <b-col
            lg="2"
            md="3"
            class="mb-50"
          >
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              class="mt-0 mt-md-2"
              size="sm"
              @click="removeItemGravidade(index)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>Deletar</span>
            </b-button>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>

        </b-row>

        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="success"
          size="sm"
          @click="addItemGravidade"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-25"
          />
          <span>Adicionar</span>
        </b-button>
      </tab-content>

      <!-- Exportações -->
      <tab-content title="Exportações">
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Exportações
              </h5>
              <small class="text-muted">
                Edite as informações das exportações.
              </small>
            </b-col>
          </b-row>

          <!-- dados_de_exportacoes -->
          <b-row
            v-for="(item, index) in dados_de_exportacoes"
            :id="index"
            :key="'exp_'+index"
            ref="rowExp"
          >

            <!-- exportacoes_pais -->
            <b-col md="12">
              <b-form-group
                label="País"
                label-for="exportacoes_pais"
              >
                <v-select
                  id="exportacoes_pais"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="selectCountry(item.pais)"
                  @input="atualizaCountry(item.pais)"
                  v-model="item.pais"
                  label="text"
                  placeholder="Selecione um País"
                />
              </b-form-group>
            </b-col>

            <!-- anos de exportacoes -->
            <b-col md="12">
              <b-row
                v-for="(item2, index2) in item.anos"
                :id="index2"
                :key="'exp_'+index2"
                ref="rowExpAnos"
              >

                <!-- exportacoes_pais_ano -->
                <b-col cols="3">
                  <b-form-group
                    label="Ano"
                    label-for="exportacoes_pais_ano"
                  >
                    <b-form-input
                      id="exportacoes_pais_ano"
                      placeholder="Ano"
                      :value="item2.ano"
                      v-model="item2.ano"
                    />
                  </b-form-group>
                </b-col>

                <!-- exportacoes_pais_descricao -->
                <b-col cols="7">
                  <b-form-group
                    label="Descrição"
                    label-for="exportacoes_pais_descricao"
                  >
                    <b-form-input
                      id="exportacoes_pais_descricao"
                      placeholder="Descrição"
                      :value="item2.descricao"
                      v-model="item2.descricao"
                    />
                  </b-form-group>
                </b-col>

                <!-- Adicionar Anos -->
                <b-col cols="2">
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-2 mt-md-2"
                    size="sm"
                    @click="removeItemExportacaoAnos(index, index2)"
                  >
                    <feather-icon
                      icon="XIcon"
                      class="mr-25"
                    />
                    <span>Del</span>
                  </b-button>
                </b-col>

              </b-row>
            </b-col>

            <!-- add Button -->
            <b-col cols="2">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                size="sm"
                @click="addItemExportacaoAnos(index)"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span>Add</span>
              </b-button>
            </b-col>

            <!-- remove Button -->
            <b-col cols="2">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2"
                size="sm"
                @click="removeItemExportacao(index, item.pais)"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-25"
                />
                <span>Deletar</span>
              </b-button>
            </b-col>

            <b-col cols="12">
              <hr>
            </b-col>

          </b-row>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            size="sm"
            @click="addItemExportacao"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-25"
            />
            <span>Adicionar</span>
          </b-button>
        </tab-content>

        <!-- Selos -->
        <tab-content title="Selos">
          <b-row>

            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Selos
              </h5>
              <small class="text-muted">Edite selos e autorizações</small>
            </b-col>

            <!-- selos_ANP -->
            <b-col cols="12">
              <b-form-group
                label="ANP"
                label-for="selos_ANP"
              >
                <v-select
                  id="selos_ANP"
                  v-model="selos_ANP"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="selos"
                  label="text"
                  placeholder="Selecione uma Opção"
                />
              </b-form-group>
            </b-col>

            <!-- selos_ANPCancelado -->
            <b-col cols="6">
              <b-form-group
                label="ANP Cancelado"
                label-for="selos_ANPCancelado"
              >
                <v-select
                  id="selos_ANPCancelado"
                  v-model="selos_ANPCancelado"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="selos"
                  label="text"
                  placeholder="Selecione uma Opção"
                />
              </b-form-group>
            </b-col>

            <!-- data_cancelamento_anp -->
            <b-col cols="6">
              <b-form-group
                label="Data de Cancelado ANP"
                label-for="data_cancelamento_anp"
              >
              <b-form-datepicker
                id="example-datepicker"
                v-model="data_cancelamento_anp"
                :value="data_cancelamento_anp"
                class="mb-1"
              />
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <hr>
            </b-col>

            <!-- selos_SAPCana -->
            <b-col cols="6">
              <b-form-group
                label="SAPCana"
                label-for="selos_SAPCana"
              >
                <v-select
                  id="selos_SAPCana"
                  v-model="selos_SAPCana"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="selos"
                  label="text"
                  placeholder="Selecione uma Opção"
                />
              </b-form-group>
            </b-col>

            <!-- selos_EUA -->
            <b-col cols="6">
              <b-form-group
                label="EUA"
                label-for="selos_EUA"
              >
                <v-select
                  id="selos_EUA"
                  v-model="selos_EUA"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="selos"
                  label="text"
                  placeholder="Selecione uma Opção"
                />
              </b-form-group>
            </b-col>

            <!-- selos_California -->
            <b-col cols="6">
              <b-form-group
                label="Califórnia"
                label-for="selos_California"
              >
                <v-select
                  id="selos_California"
                  v-model="selos_California"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="selos"
                  label="text"
                  placeholder="Selecione uma Opção"
                />
              </b-form-group>
            </b-col>

            <!-- selos_Bonsucro -->
            <b-col cols="6">
              <b-form-group
                label="Bonsucro"
                label-for="selos_Bonsucro"
              >
                <v-select
                  id="selos_Bonsucro"
                  v-model="selos_Bonsucro"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="selos"
                  label="text"
                  placeholder="Selecione uma Opção"
                />
              </b-form-group>
            </b-col>

            <!-- selos_CompromissoNacional -->
            <b-col cols="6">
              <b-form-group
                label="Compromisso Nacional"
                label-for="selos_CompromissoNacional"
              >
                <v-select
                  id="selos_CompromissoNacional"
                  v-model="selos_CompromissoNacional"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="selos"
                  label="text"
                  placeholder="Selecione uma Opção"
                />
              </b-form-group>
            </b-col>

            <!-- selos_EtanolVerde -->
            <b-col cols="6">
              <b-form-group
                label="Etanol Verde"
                label-for="selos_EtanolVerde"
              >
                <v-select
                  id="selos_EtanolVerde"
                  v-model="selos_EtanolVerde"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="selos"
                  label="text"
                  placeholder="Selecione uma Opção"
                />
              </b-form-group>
            </b-col>

            <!-- selos_EnergiaVerde -->
            <b-col cols="6">
              <b-form-group
                label="Energia Verde"
                label-for="selos_EnergiaVerde"
              >
                <v-select
                  id="selos_EnergiaVerde"
                  v-model="selos_EnergiaVerde"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="selos"
                  label="text"
                  placeholder="Selecione uma Opção"
                />
              </b-form-group>
            </b-col>

          </b-row>
        </tab-content>

      <!-- Finanças -->
      <tab-content title="Finanças">
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Vendas Líquidas
            </h5>
            <small class="text-muted">
              Edite as informações de vendas líquidas.
            </small>
          </b-col>
        </b-row>

        <!-- exame_vendas_liquidas -->
        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_vendas_liquidas"
              :id="index"
              :key="'fin_'+index"
              ref="rowFinancas"
            >

              <!-- vendas_liquidas_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="vendas_liquidas_ano"
                >
                  <b-form-input
                    id="vendas_liquidas_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- vendas_liquidas_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="vendas_liquidas_valor"
                >
                  <b-form-input
                    id="vendas_liquidas_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeVendasLiquidas(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addVendasLiquidas()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Crescimento de Vendas
            </h5>
            <small class="text-muted">Edite as informações de crescimento de vendas</small>
          </b-col>
        </b-row>

        <!-- exame_crescimento_vendas -->
        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_crescimento_vendas"
              :id="index"
              :key="'fin_'+index"
              ref="rowCrescimentoVendas"
            >

              <!-- crescimento_vendas_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="crescimento_vendas_ano"
                >
                  <b-form-input
                    id="crescimento_vendas_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- crescimento_vendas_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="crescimento_vendas_valor"
                >
                  <b-form-input
                    id="crescimento_vendas_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeCrescimentoVendas(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addCrescimentoVendas()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Lucro Líquido Ajustado
            </h5>
            <small class="text-muted">Edite as informações de lucro líquido ajustado</small>
          </b-col>
        </b-row>

        <!-- exame_lucro_liquido_ajustado -->
        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_lucro_liquido_ajustado"
              :id="index"
              :key="'fin_'+index"
              ref="rowLucroLiquidoAjustado"
            >

              <!-- lucro_liquido_ajustado_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="lucro_liquido_ajustado_ano"
                >
                  <b-form-input
                    id="lucro_liquido_ajustado_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- lucro_liquido_ajustado_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="lucro_liquido_ajustado_valor"
                >
                  <b-form-input
                    id="lucro_liquido_ajustado_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeLucroLiquidoAjustado(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addLucroLiquidoAjustado()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>


        <!-- exame_lucro_liquido_legal -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Lucro Líquido Legal
            </h5>
            <small class="text-muted">Edite as informações de lucro líquido legal</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_lucro_liquido_legal"
              :id="index"
              :key="'fin_'+index"
              ref="rowLucroLiquidoLegal"
            >

              <!-- lucro_liquido_legal_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="lucro_liquido_legal_ano"
                >
                  <b-form-input
                    id="lucro_liquido_legal_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- lucro_liquido_legal_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="lucro_liquido_legal_valor"
                >
                  <b-form-input
                    id="lucro_liquido_legal_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeLucroLiquidoLegal(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addLucroLiquidoLegal()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_patrimonio_liquido_ajustado -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Patrimônio Líquido Ajustado
            </h5>
            <small class="text-muted">Edite as informações de patrimônio líquido ajustado</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_patrimonio_liquido_ajustado"
              :id="index"
              :key="'fin_'+index"
              ref="rowPatrimonioLiquidoAjustado"
            >

              <!-- patrimonio_liquido_ajustado_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="patrimonio_liquido_ajustado_ano"
                >
                  <b-form-input
                    id="patrimonio_liquido_ajustado_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- patrimonio_liquido_ajustado_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="patrimonio_liquido_ajustado_valor"
                >
                  <b-form-input
                    id="patrimonio_liquido_ajustado_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removePatrimonioLiquidoAjustado(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addPatrimonioLiquidoAjustado()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_patrimonio_liquido_legal -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Patrimônio Líquido Legal
            </h5>
            <small class="text-muted">Edite as informações de patrimônio líquido legal</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_patrimonio_liquido_legal"
              :id="index"
              :key="'fin_'+index"
              ref="rowPatrimonioLiquidoLegal"
            >

              <!-- patrimonio_liquido_legal_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="patrimonio_liquido_legal_ano"
                >
                  <b-form-input
                    id="patrimonio_liquido_legal_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- patrimonio_liquido_legal_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="patrimonio_liquido_legal_valor"
                >
                  <b-form-input
                    id="patrimonio_liquido_legal_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removePatrimonioLiquidoLegal(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addPatrimonioLiquidoLegal()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_rentabilidade_patrimonio_ajustada -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Rentabilidade De Patrimônio Ajustada
            </h5>
            <small class="text-muted">Edite as informações de rentabilidade De patrimônio ajustada</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_rentabilidade_patrimonio_ajustada"
              :id="index"
              :key="'fin_'+index"
              ref="rowRentabilidadePatrimonioAjustada"
            >

              <!-- rentabilidade_patrimonio_ajustada_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="rentabilidade_patrimonio_ajustada_ano"
                >
                  <b-form-input
                    id="rentabilidade_patrimonio_ajustada_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- rentabilidade_patrimonio_ajustada_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="rentabilidade_patrimonio_ajustada_valor"
                >
                  <b-form-input
                    id="rentabilidade_patrimonio_ajustada_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeRentabilidadePatrimonioAjustada(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addRentabilidadePatrimonioAjustada()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_rentabilidade_patrimonio_legal -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Rentabilidade De Patrimônio Legal
            </h5>
            <small class="text-muted">Edite as informações de rentabilidade de patrimônio legal</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_rentabilidade_patrimonio_legal"
              :id="index"
              :key="'fin_'+index"
              ref="rowRentabilidadePatrimonioLegal"
            >

              <!-- rentabilidade_patrimonio_legal_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="rentabilidade_patrimonio_legal_ano"
                >
                  <b-form-input
                    id="rentabilidade_patrimonio_legal_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- rentabilidade_patrimonio_legal_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="rentabilidade_patrimonio_legal_valor"
                >
                  <b-form-input
                    id="rentabilidade_patrimonio_legal_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeRentabilidadePatrimonioLegal(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addRentabilidadePatrimonioLegal()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_capital_circulante_liquido -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Capital Circulante Líquido
            </h5>
            <small class="text-muted">Edite as informações de capital circulante líquido</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_capital_circulante_liquido"
              :id="index"
              :key="'fin_'+index"
              ref="rowCapitalCirculanteOLiquido"
            >

              <!-- capital_circulante_liquido_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="capital_circulante_liquido_ano"
                >
                  <b-form-input
                    id="capital_circulante_liquido_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- capital_circulante_liquido_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="capital_circulante_liquido_valor"
                >
                  <b-form-input
                    id="capital_circulante_liquido_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeCapitalCirculanteOLiquido(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addCapitalCirculanteOLiquido()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_liquidez_geral -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Liquidez Geral
            </h5>
            <small class="text-muted">Edite as informações de liquidez geral</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_liquidez_geral"
              :id="index"
              :key="'fin_'+index"
              ref="rowLiquidezGeral"
            >

              <!-- liquidez_geral_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="liquidez_geral_ano"
                >
                  <b-form-input
                    id="liquidez_geral_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- liquidez_geral_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="liquidez_geral_valor"
                >
                  <b-form-input
                    id="liquidez_geral_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeLiquidezGeral(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addLiquidezGeral()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_endividamento_geral -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Endividamento Geral
            </h5>
            <small class="text-muted">Edite as informações de endividamento geral</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_endividamento_geral"
              :id="index"
              :key="'fin_'+index"
              ref="rowEndividamentoGeral"
            >

              <!-- endividamento_geral_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="endividamento_geral_ano"
                >
                  <b-form-input
                    id="endividamento_geral_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- endividamento_geral_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="endividamento_geral_valor"
                >
                  <b-form-input
                    id="endividamento_geral_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeEndividamentoGeral(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addEndividamentoGeral()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_endividamento_longo_prazo -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Endividamento De Longo Prazo
            </h5>
            <small class="text-muted">Edite as informações de endividamento de longo prazo</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_endividamento_longo_prazo"
              :id="index"
              :key="'fin_'+index"
              ref="rowEndividamentoLongoPrazo"
            >

              <!-- endividamento_longo_prazo_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="endividamento_longo_prazo_ano"
                >
                  <b-form-input
                    id="endividamento_longo_prazo_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- endividamento_longo_prazo_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="endividamento_longo_prazo_valor"
                >
                  <b-form-input
                    id="endividamento_longo_prazo_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeEndividamentoLongoPrazo(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addEndividamentoLongoPrazo()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_riqueza_criada -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Riqueza Criada
            </h5>
            <small class="text-muted">Edite as informações de riqueza criada</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_riqueza_criada"
              :id="index"
              :key="'fin_'+index"
              ref="rowRiquezaCriada"
            >

              <!-- riqueza_criada_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="riqueza_criada_ano"
                >
                  <b-form-input
                    id="riqueza_criada_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- riqueza_criada_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="riqueza_criada_valor"
                >
                  <b-form-input
                    id="riqueza_criada_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeRiquezaCriada(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addRiquezaCriada()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_numero_empregados -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Número De Empregados
            </h5>
            <small class="text-muted">Edite as informações de número de empregados</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_numero_empregados"
              :id="index"
              :key="'fin_'+index"
              ref="rowNumeroEmpregados"
            >

              <!-- numero_empregados_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="numero_empregados_ano"
                >
                  <b-form-input
                    id="numero_empregados_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- numero_empregados_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="numero_empregados_valor"
                >
                  <b-form-input
                    id="numero_empregados_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeNumeroEmpregados(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addNumeroEmpregados()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_riqueza_criada_por_empregado -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Riqueza Criada Por Empregado
            </h5>
            <small class="text-muted">Edite as informações de riqueza criada por empregado</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_riqueza_criada_por_empregado"
              :id="index"
              :key="'fin_'+index"
              ref="rowRiquezaCriadaPorEmpregado"
            >

              <!-- riqueza_criada_por_empregado_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="riqueza_criada_por_empregado_ano"
                >
                  <b-form-input
                    id="riqueza_criada_por_empregado_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- riqueza_criada_por_empregado_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="riqueza_criada_por_empregado_valor"
                >
                  <b-form-input
                    id="riqueza_criada_por_empregado_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeRiquezaCriadaPorEmpregado(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addRiquezaCriadaPorEmpregado()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_ebitda -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Ebitda
            </h5>
            <small class="text-muted">Edite as informações de ebitda</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_ebitda"
              :id="index"
              :key="'fin_'+index"
              ref="rowEbitda"
            >

              <!-- ebitda_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="ebitda_ano"
                >
                  <b-form-input
                    id="ebitda_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- ebitda_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="ebitda_valor"
                >
                  <b-form-input
                    id="ebitda_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeEbitda(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addEbitda()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_salarios_encargos -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Salários E Encargos
            </h5>
            <small class="text-muted">Edite as informações de salários e encargos</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_salarios_encargos"
              :id="index"
              :key="'fin_'+index"
              ref="rowSalariosEncargos"
            >

              <!-- salarios_encargos_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="salarios_encargos_ano"
                >
                  <b-form-input
                    id="salarios_encargos_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- salarios_encargos_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="salarios_encargos_valor"
                >
                  <b-form-input
                    id="salarios_encargos_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeSalariosEncargos(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addSalariosEncargos()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_tributos -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Tributos
            </h5>
            <small class="text-muted">Edite as informações de tributos</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_tributos"
              :id="index"
              :key="'fin_'+index"
              ref="rowTributos"
            >

              <!-- tributos_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="tributos_ano"
                >
                  <b-form-input
                    id="tributos_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- tributos_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="tributos_valor"
                >
                  <b-form-input
                    id="tributos_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeTributos(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addTributos()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_valor_exportado -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Valor Exportado
            </h5>
            <small class="text-muted">Edite as informações de valor exportado</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_valor_exportado"
              :id="index"
              :key="'fin_'+index"
              ref="rowValorExportado"
            >

              <!-- valor_exportado_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="valor_exportado_ano"
                >
                  <b-form-input
                    id="valor_exportado_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- valor_exportado_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="valor_exportado_valor"
                >
                  <b-form-input
                    id="valor_exportado_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeValorExportado(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addValorExportado()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_percentual_vendas_exportacao -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Percentual De Vendas Com Exportação
            </h5>
            <small class="text-muted">Edite as informações de percentual de vendas com exportação</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_percentual_vendas_exportacao"
              :id="index"
              :key="'fin_'+index"
              ref="rowPercentualVendasExportacao"
            >

              <!-- percentual_vendas_exportacao_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="percentual_vendas_exportacao_ano"
                >
                  <b-form-input
                    id="percentual_vendas_exportacao_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- percentual_vendas_exportacao_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="percentual_vendas_exportacao_valor"
                >
                  <b-form-input
                    id="percentual_vendas_exportacao_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removePercentualVendasExportacao(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addPercentualVendasExportacao()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_maiores_dividendos -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Maiores Dividendos
            </h5>
            <small class="text-muted">Edite as informações de maiores dividendos</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_maiores_dividendos"
              :id="index"
              :key="'fin_'+index"
              ref="rowMaioresDividendos"
            >

              <!-- maiores_dividendos_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="maiores_dividendos_ano"
                >
                  <b-form-input
                    id="maiores_dividendos_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- maiores_dividendos_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="maiores_dividendos_valor"
                >
                  <b-form-input
                    id="maiores_dividendos_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeMaioresDividendos(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addMaioresDividendos()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_margem_vendas -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Margem De Vendas
            </h5>
            <small class="text-muted">Edite as informações de margem de vendas</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_margem_vendas"
              :id="index"
              :key="'fin_'+index"
              ref="rowMargemVendas"
            >

              <!-- margem_vendas_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="margem_vendas_ano"
                >
                  <b-form-input
                    id="margem_vendas_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- margem_vendas_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="margem_vendas_valor"
                >
                  <b-form-input
                    id="margem_vendas_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeMargemVendas(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addMargemVendas()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_giro -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Capital De Giro
            </h5>
            <small class="text-muted">Edite as informações de capital de giro</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_giro"
              :id="index"
              :key="'fin_'+index"
              ref="rowGiro"
            >

              <!-- giro_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="giro_ano"
                >
                  <b-form-input
                    id="giro_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- giro_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="giro_valor"
                >
                  <b-form-input
                    id="giro_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeGiro(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addGiro()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_liquidez_corrente -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Liquidez Corrente
            </h5>
            <small class="text-muted">Edite as informações de liquidez corrente</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_liquidez_corrente"
              :id="index"
              :key="'fin_'+index"
              ref="rowLiquidezCorrente"
            >

              <!-- liquidez_corrente_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="liquidez_corrente_ano"
                >
                  <b-form-input
                    id="liquidez_corrente_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- liquidez_corrente_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="liquidez_corrente_valor"
                >
                  <b-form-input
                    id="liquidez_corrente_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeLiquidezCorrente(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addLiquidezCorrente()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

        <!-- exame_total_ativo -->
        <b-row>
          <b-col cols="12">
            <hr>
          </b-col>
        
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Ativo Total
            </h5>
            <small class="text-muted">Edite as informações de ativo total</small>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-row
              v-for="(item, index) in exame_total_ativo"
              :id="index"
              :key="'fin_'+index"
              ref="rowTotalAtivo"
            >

              <!-- total_ativo_ano -->
              <b-col cols="3">
                <b-form-group
                  label="Ano"
                  label-for="total_ativo_ano"
                >
                  <b-form-input
                    id="total_ativo_ano"
                    placeholder="Ano"
                    :value="item.ano"
                    v-model="item.ano"
                  />
                </b-form-group>
              </b-col>

              <!-- total_ativo_valor -->
              <b-col cols="7">
                <b-form-group
                  label="Valor"
                  label-for="total_ativo_valor"
                >
                  <b-form-input
                    id="total_ativo_valor"
                    placeholder="Valor"
                    :value="item.valor"
                    v-model="item.valor"
                  />
                </b-form-group>
              </b-col>

              <!-- Adicionar Anos -->
              <b-col cols="2">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-2 mt-md-2"
                  size="sm"
                  @click="removeTotalAtivo(index)"
                >
                  <feather-icon
                    icon="XIcon"
                    class="mr-25"
                  />
                  <span>Del</span>
                </b-button>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </b-col>

          <!-- add Button -->
          <b-col cols="2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-success"
              class="mt-0 mt-md-2"
              size="sm"
              @click="addTotalAtivo()"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-25"
              />
              <span>Add</span>
            </b-button>
          </b-col>
        </b-row>

      </tab-content>
        
    </form-wizard>
  </b-overlay>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BImg,
  BFormFile,
  BOverlay,
  BButton,
  BFormDatepicker
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt';
import vSelect from 'vue-select';
import Cleave from 'vue-cleave-component';
import 'cleave.js/dist/addons/cleave-phone.us';
import Ripple from 'vue-ripple-directive'
import { heightTransition } from '@core/mixins/ui/transition'
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    ToastificationContent,
    BImg,
    BFormFile,
    BOverlay,
    vSelect,
    Cleave,
    BButton,
    BFormDatepicker
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      id: '',
      usina_id: '',
      descricao: '',
      maxChar: 65535,
      loading: false,
      usinaName: [],
      capacidade_moagem_ton_cana_dia: '',
      capacidade_moagem_ton_cana_hora: '',
      capacidade_moagem_ton_cana_safra: '',
      se_a_moagem_foi_calculada: '',
      capacidade_producao_etanol_total: '',
      capacidade_producao_etanol_anidro: '',
      capacidade_producao_etanol_hidratado: '',
      california_intensidade_carbono: '',
      destino_proprietario_cogeracao: [],
      garantia_fisica: '',
      potencia_instalada: '',
      cogeracao_nome: '',
      cogeracao_destino: '',
      cogeracao_empresa: '',
      cogeracao_participacao: '',
      cogeracao_potencia: '',
      producao_acucar_sacas_dia: '',
      producao_acucar_ton_safra: '',
      producao_acucar_ranking_sacas_dia: '',
      producao_acucar_ranking_ton_safra: '',
      geracao_centro_gravidade: [],
      dados_de_exportacoes: [],
      paisesExportacoes: [],
      paisesName: [],
      moagemCalculadaName: [
        {"value": "nao","text":"Não"},
        {"value": "sim","text":"Sim"}
      ],
      statusUsina: [
        {"value": "Ativa","text":"Ativa"},
        {"value": "Inativa","text":"Inativa"}
      ],
      tipoRecuperacao: [
        {"value": "Ativo","text":"Ativo"},
        {"value": "Recuperação judicial","text":"Recuperação judicial"},
        {"value": "Falida","text":"Falida"}
      ],
      recuperacao_falidas: '',
      status_da_usina: '',
      tipoProducao: [
        {"value": "Etanol","text":"Etanol"},
        {"value": "Açúcar","text":"Açúcar"},
        {"value": "Mista","text":"Mista"},
        {"value": "Inativas","text":"Inativas"}
      ],
      tipo_de_producao: '',
      selos: [
        {"value": "true","text":"Sim"},
        {"value": "false","text":"Não"},
      ],
      selos_ANP: '',
      selos_ANPCancelado: [{"value": "false","text":"Não"}],
      selos_SAPCana: [{"value": "false","text":"Não"}],
      selos_EUA: [{"value": "false","text":"Não"}],
      selos_California: [{"value": "false","text":"Não"}],
      selos_Bonsucro: [{"value": "false","text":"Não"}],
      selos_CompromissoNacional: [{"value": "false","text":"Não"}],
      selos_EtanolVerde: [{"value": "false","text":"Não"}],
      selos_EnergiaVerde: [{"value": "false","text":"Não"}],
      rank_anidro: '',
      rank_hidratado: '',
      rank_etanol: '',
      rank_moagem: '',
      rank_energia: '',
      data_cancelamento_anp: '',
      exame_vendas_liquidas: [],
      exame_crescimento_vendas: [],
      exame_lucro_liquido_ajustado: [],
      exame_lucro_liquido_legal: [],
      exame_patrimonio_liquido_ajustado: [],
      exame_patrimonio_liquido_legal: [],
      exame_rentabilidade_patrimonio_ajustada: [],
      exame_rentabilidade_patrimonio_legal: [],
      exame_capital_circulante_liquido: [],
      exame_liquidez_geral: [],
      exame_endividamento_geral: [],
      exame_endividamento_longo_prazo: [],
      exame_riqueza_criada: [],
      exame_numero_empregados: [],
      exame_riqueza_criada_por_empregado: [],
      exame_ebitda: [],
      exame_salarios_encargos: [],
      exame_tributos: [],
      exame_valor_exportado: [],
      exame_percentual_vendas_exportacao: [],
      exame_maiores_dividendos: [],
      exame_margem_vendas: [],
      exame_giro: [],
      exame_liquidez_corrente: [],
      exame_total_ativo: [],
      dirigentes: '',
      materia_prima: '',
      producao_milho_milhoes_litros: '',
      producao_milho_mil_toneladas: '',
      ddg: '',
      oleo: '',
      combustivel_usado: '',
      tancagem: '',
      biogasBiometano: '',
      graficoCentroGravidade: '',
      activeIndex: 5
    }
  },
  mounted() {
    this.initTrHeight();
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight);
  },
  computed:{
    ...mapGetters([
      'selectLoading',
    ])
  },
  methods: {
    atualizaCountry(pais){
        if(pais){
          if(!this.paisesExportacoes.includes(pais.text)){
            this.paisesExportacoes.push(pais.text);
          }
        }
    },
    selectCountry(pais){
        let paisesExp = [...this.paisesExportacoes];    
        if(pais){
          if(paisesExp.includes(pais.text)){
            const index = paisesExp.indexOf(pais.text);
            if (index > -1) {
              paisesExp.splice(index, 1);
            }
          }
        }

        let returnpaisesName = [];
        let paisesNameSelect = [...this.paisesName];  
        paisesNameSelect.forEach((item) => {
          if(!paisesExp.includes(item.text)){
            returnpaisesName.push(item);
          }
        });

        return returnpaisesName;
    },
    addItem() {
      this.destino_proprietario_cogeracao.push({
        id: this.destino_proprietario_cogeracao.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    addItemGravidade() {
      this.geracao_centro_gravidade.push({
        id: this.geracao_centro_gravidade.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowGrav[0].offsetHeight);
      });
    },
    addItemExportacao() {
      this.dados_de_exportacoes.push({
        id: this.dados_de_exportacoes.length,
        anos: [
          {
            id: 0
          }
        ]
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowExp[0].offsetHeight);
      });
    },
    addVendasLiquidas() {
      this.exame_vendas_liquidas.push({
        id: this.exame_vendas_liquidas.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowFinancas[0].offsetHeight);
      });
    },
    addCrescimentoVendas() {
      this.exame_crescimento_vendas.push({
        id: this.exame_crescimento_vendas.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowCrescimentoVendas[0].offsetHeight);
      });
    },
    addLucroLiquidoAjustado() {
      this.exame_lucro_liquido_ajustado.push({
        id: this.exame_lucro_liquido_ajustado.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowLucroLiquidoAjustado[0].offsetHeight);
      });
    },
    addLucroLiquidoLegal() {
      this.exame_lucro_liquido_legal.push({
        id: this.exame_lucro_liquido_legal.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowLucroLiquidoLegal[0].offsetHeight);
      });
    },
    addPatrimonioLiquidoAjustado() {
      this.exame_patrimonio_liquido_ajustado.push({
        id: this.exame_patrimonio_liquido_ajustado.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowPatrimonioLiquidoAjustado[0].offsetHeight);
      });
    },
    addPatrimonioLiquidoLegal() {
      this.exame_patrimonio_liquido_legal.push({
        id: this.exame_patrimonio_liquido_legal.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowPatrimonioLiquidoLegal[0].offsetHeight);
      });
    },
    addRentabilidadePatrimonioAjustada() {
      this.exame_rentabilidade_patrimonio_ajustada.push({
        id: this.exame_rentabilidade_patrimonio_ajustada.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowRentabilidadePatrimonioAjustada[0].offsetHeight);
      });
    },
    addRentabilidadePatrimonioLegal() {
      this.exame_rentabilidade_patrimonio_legal.push({
        id: this.exame_rentabilidade_patrimonio_legal.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowRentabilidadePatrimonioLegal[0].offsetHeight);
      });
    },
    addCapitalCirculanteLiquido() {
      this.exame_capital_circulante_liquido.push({
        id: this.exame_capital_circulante_liquido.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowCapitalCirculanteLiquido[0].offsetHeight);
      });
    },
    addLiquidezGeral() {
      this.exame_liquidez_geral.push({
        id: this.exame_liquidez_geral.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowLiquidezGeral[0].offsetHeight);
      });
    },
    addEndividamentoGeral() {
      this.exame_endividamento_geral.push({
        id: this.exame_endividamento_geral.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowEndividamentoGeral[0].offsetHeight);
      });
    },
    addEndividamentoLongoPrazo() {
      this.exame_endividamento_longo_prazo.push({
        id: this.exame_endividamento_longo_prazo.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowEndividamentoLongoPrazo[0].offsetHeight);
      });
    },
    addRiquezaCriada() {
      this.exame_riqueza_criada.push({
        id: this.exame_riqueza_criada.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowRiquezaCriada[0].offsetHeight);
      });
    },
    addNumeroEmpregados() {
      this.exame_numero_empregados.push({
        id: this.exame_numero_empregados.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowNumeroEmpregados[0].offsetHeight);
      });
    },
    addRiquezaCriadaPorEmpregado() {
      this.exame_riqueza_criada_por_empregado.push({
        id: this.exame_riqueza_criada_por_empregado.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowRiquezaCriadaPorEmpregado[0].offsetHeight);
      });
    },
    addEbitda() {
      this.exame_ebitda.push({
        id: this.exame_ebitda.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowEbitda[0].offsetHeight);
      });
    },
    addSalariosEncargos() {
      this.exame_salarios_encargos.push({
        id: this.exame_salarios_encargos.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowSalariosEncargos[0].offsetHeight);
      });
    },
    addTributos() {
      this.exame_tributos.push({
        id: this.exame_tributos.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowTributos[0].offsetHeight);
      });
    },
    addValorExportado() {
      this.exame_valor_exportado.push({
        id: this.exame_valor_exportado.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowValorExportado[0].offsetHeight);
      });
    },
    addPercentualVendasExportacao() {
      this.exame_percentual_vendas_exportacao.push({
        id: this.exame_percentual_vendas_exportacao.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowPercentualVendasExportacao[0].offsetHeight);
      });
    },
    addMaioresDividendos() {
      this.exame_maiores_dividendos.push({
        id: this.exame_maiores_dividendos.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowMaioresDividendos[0].offsetHeight);
      });
    },
    addMargemVendas() {
      this.exame_margem_vendas.push({
        id: this.exame_margem_vendas.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowMargemVendas[0].offsetHeight);
      });
    },
    addGiro() {
      this.exame_giro.push({
        id: this.exame_giro.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowGiro[0].offsetHeight);
      });
    },
    addLiquidezCorrente() {
      this.exame_liquidez_corrente.push({
        id: this.exame_liquidez_corrente.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowLiquidezCorrente[0].offsetHeight);
      });
    },
    addTotalAtivo() {
      this.exame_total_ativo.push({
        id: this.exame_total_ativo.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowTotalAtivo[0].offsetHeight);
      });
    },
    addItemExportacaoAnos(index) {
      this.dados_de_exportacoes[index].anos.push({
        id: this.dados_de_exportacoes[index].anos.length,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.rowExp[0].offsetHeight);
        this.trAddHeight(this.$refs.rowExpAnos[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.destino_proprietario_cogeracao.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    removeItemGravidade(index) {
      this.geracao_centro_gravidade.splice(index, 1);
      this.trTrimHeight(this.$refs.rowGrav[0].offsetHeight);
    },
    removeItemExportacao(index, pais) {
      if(pais){
        if(this.paisesExportacoes.includes(pais.text)){
          const index = this.paisesExportacoes.indexOf(pais.text);
          if (index > -1) {
            this.paisesExportacoes.splice(index, 1);
          }
        }
      }

      this.dados_de_exportacoes.splice(index, 1);
      this.trTrimHeight(this.$refs.rowExp[0].offsetHeight);
    },
    removeItemExportacaoAnos(index, index2) {
      this.dados_de_exportacoes[index].anos.splice(index2, 1);
      this.trTrimHeight(this.$refs.rowExp[0].offsetHeight);
      this.trTrimHeight(this.$refs.rowExpAnos[0].offsetHeight);
    },
    removeVendasLiquidas(index) {
      this.exame_vendas_liquidas.splice(index, 1);
      this.trTrimHeight(this.$refs.rowFinancas[0].offsetHeight);
    },
    removeCrescimentoVendas(index) {
      this.exame_crescimento_vendas.splice(index, 1);
      this.trTrimHeight(this.$refs.rowCrescimentoVendas[0].offsetHeight);
    },
    removeLucroLiquidoAjustado(index) {
      this.exame_lucro_liquido_ajustado.splice(index, 1);
      this.trTrimHeight(this.$refs.rowLucroLiquidoAjustado[0].offsetHeight);
    },
    removeLucroLiquidoLegal(index) {
      this.exame_lucro_liquido_legal.splice(index, 1);
      this.trTrimHeight(this.$refs.rowLucroLiquidoLegal[0].offsetHeight);
    },
    removePatrimonioLiquidoAjustado(index) {
      this.exame_patrimonio_liquido_ajustado.splice(index, 1);
      this.trTrimHeight(this.$refs.rowPatrimonioLiquidoAjustado[0].offsetHeight);
    },
    removePatrimonioLiquidoLegal(index) {
      this.exame_patrimonio_liquido_legal.splice(index, 1);
      this.trTrimHeight(this.$refs.rowPatrimonioLiquidoLegal[0].offsetHeight);
    },
    removeRentabilidadePatrimonioAjustada(index) {
      this.exame_rentabilidade_patrimonio_ajustada.splice(index, 1);
      this.trTrimHeight(this.$refs.rowRentabilidadePatrimonioAjustada[0].offsetHeight);
    },
    removeRentabilidadePatrimonioLegal(index) {
      this.exame_rentabilidade_patrimonio_legal.splice(index, 1);
      this.trTrimHeight(this.$refs.rowRentabilidadePatrimonioLegal[0].offsetHeight);
    },
    removeCapitalCirculanteLiquido(index) {
      this.exame_capital_circulante_liquido.splice(index, 1);
      this.trTrimHeight(this.$refs.rowCapitalCirculanteLiquido[0].offsetHeight);
    },
    removeLiquidezGeral(index) {
      this.exame_liquidez_geral.splice(index, 1);
      this.trTrimHeight(this.$refs.rowLiquidezGeral[0].offsetHeight);
    },
    removeEndividamentoGeral(index) {
      this.exame_endividamento_geral.splice(index, 1);
      this.trTrimHeight(this.$refs.rowEndividamentoGeral[0].offsetHeight);
    },
    removeEndividamentoLongoPrazo(index) {
      this.exame_endividamento_longo_prazo.splice(index, 1);
      this.trTrimHeight(this.$refs.rowEndividamentoLongoPrazo[0].offsetHeight);
    },
    removeRiquezaCriada(index) {
      this.exame_riqueza_criada.splice(index, 1);
      this.trTrimHeight(this.$refs.rowRiquezaCriada[0].offsetHeight);
    },
    removeNumeroEmpregados(index) {
      this.exame_numero_empregados.splice(index, 1);
      this.trTrimHeight(this.$refs.rowNumeroEmpregados[0].offsetHeight);
    },
    removeRiquezaCriadaPorEmpregado(index) {
      this.exame_riqueza_criada_por_empregado.splice(index, 1);
      this.trTrimHeight(this.$refs.rowRiquezaCriadaPorEmpregado[0].offsetHeight);
    },
    removeEbitda(index) {
      this.exame_ebitda.splice(index, 1);
      this.trTrimHeight(this.$refs.rowEbitda[0].offsetHeight);
    },
    removeSalariosEncargos(index) {
      this.exame_salarios_encargos.splice(index, 1);
      this.trTrimHeight(this.$refs.rowSalariosEncargos[0].offsetHeight);
    },
    removeTributos(index) {
      this.exame_tributos.splice(index, 1);
      this.trTrimHeight(this.$refs.rowTributos[0].offsetHeight);
    },
    removeValorExportado(index) {
      this.exame_valor_exportado.splice(index, 1);
      this.trTrimHeight(this.$refs.rowValorExportado[0].offsetHeight);
    },
    removePercentualVendasExportacao(index) {
      this.exame_percentual_vendas_exportacao.splice(index, 1);
      this.trTrimHeight(this.$refs.rowPercentualVendasExportacao[0].offsetHeight);
    },
    removeMaioresDividendos(index) {
      this.exame_maiores_dividendos.splice(index, 1);
      this.trTrimHeight(this.$refs.rowMaioresDividendos[0].offsetHeight);
    },
    removeMargemVendas(index) {
      this.exame_margem_vendas.splice(index, 1);
      this.trTrimHeight(this.$refs.rowMargemVendas[0].offsetHeight);
    },
    removeGiro(index) {
      this.exame_giro.splice(index, 1);
      this.trTrimHeight(this.$refs.rowGiro[0].offsetHeight);
    },
    removeLiquidezCorrente(index) {
      this.exame_liquidez_corrente.splice(index, 1);
      this.trTrimHeight(this.$refs.rowLiquidezCorrente[0].offsetHeight);
    },
    removeTotalAtivo(index) {
      this.exame_total_ativo.splice(index, 1);
      this.trTrimHeight(this.$refs.rowTotalAtivo[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    async formSubmitted() {
      let params = new FormData();

      // ID da Usina
      params.append('id', this.$route.params.id);

      //Usina
      params.append('usina_id', this.usina_id ? this.usina_id.value : '');
      params.append('status_da_usina', this.status_da_usina ? this.status_da_usina.value : '');
      params.append('recuperacao_falidas', this.recuperacao_falidas ? this.recuperacao_falidas.value : '');
      params.append('tipo_de_producao', this.tipo_de_producao ? this.tipo_de_producao.value : '');
      params.append('california_intensidade_carbono', this.california_intensidade_carbono);
      params.append('dirigentes', this.dirigentes);
      params.append('materia_prima', this.materia_prima);
      params.append('producao_milho_milhoes_litros', this.producao_milho_milhoes_litros);
      params.append('producao_milho_mil_toneladas', this.producao_milho_mil_toneladas);
      params.append('ddg', this.ddg);
      params.append('oleo', this.oleo);
      params.append('combustivel_usado', this.combustivel_usado);
      params.append('tancagem', this.tancagem);
      params.append('biogasBiometano', this.biogasBiometano);
      params.append('graficoCentroGravidade', this.graficoCentroGravidade);

      //Capacidade de moagem
      params.append('capacidade_moagem_ton_cana_dia', this.capacidade_moagem_ton_cana_dia);
      params.append('capacidade_moagem_ton_cana_hora', this.capacidade_moagem_ton_cana_hora);
      params.append('capacidade_moagem_ton_cana_safra', this.capacidade_moagem_ton_cana_safra);
      params.append('se_a_moagem_foi_calculada', this.se_a_moagem_foi_calculada ? this.se_a_moagem_foi_calculada.value : '');
      params.append('rank_moagem', this.rank_moagem);

      //Capacidade de etanol
      params.append('capacidade_producao_etanol_anidro', this.capacidade_producao_etanol_anidro);
      params.append('rank_anidro', this.rank_anidro);
      params.append('capacidade_producao_etanol_hidratado', this.capacidade_producao_etanol_hidratado);
      params.append('rank_hidratado', this.rank_hidratado);
      params.append('capacidade_producao_etanol_total', this.capacidade_producao_etanol_total);
      params.append('rank_etanol', this.rank_etanol);

      //Capacidade de açúcar
      params.append('producao_acucar_sacas_dia', this.producao_acucar_sacas_dia);
      params.append('producao_acucar_ranking_sacas_dia', this.producao_acucar_ranking_sacas_dia);
      params.append('producao_acucar_ton_safra', this.producao_acucar_ton_safra);
      params.append('producao_acucar_ranking_ton_safra', this.producao_acucar_ranking_ton_safra);

      //Potência
      params.append('potencia_instalada', this.potencia_instalada);
      params.append('garantia_fisica', this.garantia_fisica);
      params.append('rank_energia', this.rank_energia);

      //Cogeração
      params.append('destino_proprietario_cogeracao', this.destino_proprietario_cogeracao ? JSON.stringify(this.destino_proprietario_cogeracao) : '');

      //Geração no centro de atividade das usinas
      params.append('geracao_centro_gravidade', this.geracao_centro_gravidade ? JSON.stringify(this.geracao_centro_gravidade) : '');

      //Exportações
      params.append('dados_de_exportacoes', this.dados_de_exportacoes ? JSON.stringify(this.dados_de_exportacoes) : '');

      //Selos
      params.append('selos_ANP', this.selos_ANP ? this.selos_ANP.value : '');
      params.append('selos_ANPCancelado', this.selos_ANPCancelado ? this.selos_ANPCancelado.value : '');
      params.append('selos_SAPCana', this.selos_SAPCana ? this.selos_SAPCana.value : '');
      params.append('selos_EUA', this.selos_EUA ? this.selos_EUA.value : '');
      params.append('selos_California', this.selos_California ? this.selos_California.value : '');
      params.append('selos_Bonsucro', this.selos_Bonsucro ? this.selos_Bonsucro.value : '');
      params.append('selos_CompromissoNacional', this.selos_CompromissoNacional ? this.selos_CompromissoNacional.value : '');
      params.append('selos_EtanolVerde', this.selos_EtanolVerde ? this.selos_EtanolVerde.value : '');
      params.append('selos_EnergiaVerde', this.selos_EnergiaVerde ? this.selos_EnergiaVerde.value : '');
      params.append('data_cancelamento_anp', this.data_cancelamento_anp ? this.data_cancelamento_anp : '');

      //Finanças
      params.append('exame_vendas_liquidas', this.exame_vendas_liquidas ? JSON.stringify(this.exame_vendas_liquidas) : '');
      params.append('exame_crescimento_vendas', this.exame_crescimento_vendas ? JSON.stringify(this.exame_crescimento_vendas) : '');
      params.append('exame_lucro_liquido_ajustado', this.exame_lucro_liquido_ajustado ? JSON.stringify(this.exame_lucro_liquido_ajustado) : '');
      params.append('exame_lucro_liquido_legal', this.exame_lucro_liquido_legal ? JSON.stringify(this.exame_lucro_liquido_legal) : '');
      params.append('exame_patrimonio_liquido_ajustado', this.exame_patrimonio_liquido_ajustado ? JSON.stringify(this.exame_patrimonio_liquido_ajustado) : '');
      params.append('exame_patrimonio_liquido_legal', this.exame_patrimonio_liquido_legal ? JSON.stringify(this.exame_patrimonio_liquido_legal) : '');
      params.append('exame_rentabilidade_patrimonio_ajustada', this.exame_rentabilidade_patrimonio_ajustada ? JSON.stringify(this.exame_rentabilidade_patrimonio_ajustada) : '');
      params.append('exame_rentabilidade_patrimonio_legal', this.exame_rentabilidade_patrimonio_legal ? JSON.stringify(this.exame_rentabilidade_patrimonio_legal) : '');
      params.append('exame_capital_circulante_liquido', this.exame_capital_circulante_liquido ? JSON.stringify(this.exame_capital_circulante_liquido) : '');
      params.append('exame_liquidez_geral', this.exame_liquidez_geral ? JSON.stringify(this.exame_liquidez_geral) : '');
      params.append('exame_endividamento_geral', this.exame_endividamento_geral ? JSON.stringify(this.exame_endividamento_geral) : '');
      params.append('exame_endividamento_longo_prazo', this.exame_endividamento_longo_prazo ? JSON.stringify(this.exame_endividamento_longo_prazo) : '');
      params.append('exame_riqueza_criada', this.exame_riqueza_criada ? JSON.stringify(this.exame_riqueza_criada) : '');
      params.append('exame_numero_empregados', this.exame_numero_empregados ? JSON.stringify(this.exame_numero_empregados) : '');
      params.append('exame_riqueza_criada_por_empregado', this.exame_riqueza_criada_por_empregado ? JSON.stringify(this.exame_riqueza_criada_por_empregado) : '');
      params.append('exame_ebitda', this.exame_ebitda ? JSON.stringify(this.exame_ebitda) : '');
      params.append('exame_salarios_encargos', this.exame_salarios_encargos ? JSON.stringify(this.exame_salarios_encargos) : '');
      params.append('exame_tributos', this.exame_tributos ? JSON.stringify(this.exame_tributos) : '');
      params.append('exame_valor_exportado', this.exame_valor_exportado ? JSON.stringify(this.exame_valor_exportado) : '');
      params.append('exame_percentual_vendas_exportacao', this.exame_percentual_vendas_exportacao ? JSON.stringify(this.exame_percentual_vendas_exportacao) : '');
      params.append('exame_maiores_dividendos', this.exame_maiores_dividendos ? JSON.stringify(this.exame_maiores_dividendos) : '');
      params.append('exame_margem_vendas', this.exame_margem_vendas ? JSON.stringify(this.exame_margem_vendas) : '');
      params.append('exame_giro', this.exame_giro ? JSON.stringify(this.exame_giro) : '');
      params.append('exame_liquidez_corrente', this.exame_liquidez_corrente ? JSON.stringify(this.exame_liquidez_corrente) : '');
      params.append('exame_total_ativo', this.exame_total_ativo ? JSON.stringify(this.exame_total_ativo) : '');

      this.loading = true;
      await useJwt.request('/api/usina/info/edit', params).then(request => {
        this.loading = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: request.data.status,
            text: request.data.msg,
            icon: request.data.status == 'success' ? 'CheckCircleIcon' : 'XCircleIcon',
            variant: request.data.status == 'success' ? 'success' : 'danger',
          },
        });
      });
    },
  },
  async created() {    
    window.addEventListener('resize', this.initTrHeight);

    //Carrega todos os países
    this.loading = true;
    await useJwt.request('/api/bandeira/all').then(request => {  
      this.loading = false;    
      this.paisesName = request.data;
    });

    //Carrega todas as usinas
    this.loading = true;
    await useJwt.request('/api/usina/selectall').then(request => {      
      this.loading = false;
      this.usinaName = request.data;
    });

    //Carrega a informação da usina selecionada
    this.loading = true;
    await useJwt.request('/api/usina/info/select', {id: this.$route.params.id}).then(async request => {
      this.loading = false;
      this.id = request.data.id;
      this.usina_id = request.data.usina_id ? await this.usinaName.find(item => item.value == request.data.usina_id) : '';
      this.capacidade_moagem_ton_cana_dia = request.data.capacidade_moagem_ton_cana_dia;
      this.capacidade_moagem_ton_cana_hora = request.data.capacidade_moagem_ton_cana_hora;
      this.capacidade_moagem_ton_cana_safra = request.data.capacidade_moagem_ton_cana_safra;
      this.capacidade_producao_etanol_total = request.data.capacidade_producao_etanol_total;
      this.se_a_moagem_foi_calculada = request.data.se_a_moagem_foi_calculada ? await this.moagemCalculadaName.find(item => item.value == request.data.se_a_moagem_foi_calculada) : this.moagemCalculadaName[0];
      this.capacidade_producao_etanol_anidro = request.data.capacidade_producao_etanol_anidro;
      this.capacidade_producao_etanol_hidratado = request.data.capacidade_producao_etanol_hidratado;
      this.potencia_instalada = request.data.potencia_instalada;
      this.garantia_fisica = request.data.garantia_fisica;
      this.producao_acucar_sacas_dia = request.data.producao_acucar_sacas_dia;
      this.producao_acucar_ton_safra = request.data.producao_acucar_ton_safra;
      this.producao_acucar_ranking_sacas_dia = request.data.producao_acucar_ranking_sacas_dia;
      this.producao_acucar_ranking_ton_safra = request.data.producao_acucar_ranking_ton_safra;
      this.status_da_usina = request.data.status_da_usina ? await this.statusUsina.find(item => item.value == request.data.status_da_usina) : this.statusUsina[0];
      this.tipo_de_producao = request.data.tipo_de_producao ? await this.tipoProducao.find(item => item.value == request.data.tipo_de_producao) : this.tipoProducao[0];
      this.california_intensidade_carbono = request.data.california_intensidade_carbono;
      this.rank_anidro = request.data.rank_anidro;
      this.rank_hidratado = request.data.rank_hidratado;
      this.rank_etanol = request.data.rank_etanol;
      this.rank_moagem = request.data.rank_moagem;
      this.rank_energia = request.data.rank_energia;
      this.recuperacao_falidas = request.data.recuperacao_falidas ? await this.tipoRecuperacao.find(item => item.value == request.data.recuperacao_falidas) : this.tipoRecuperacao[0];
      this.data_cancelamento_anp = request.data.data_cancelamento_anp;
      this.dirigentes = request.data.dirigentes;
      this.materia_prima = request.data.materia_prima;
      this.producao_milho_milhoes_litros = request.data.producao_milho_milhoes_litros;
      this.producao_milho_mil_toneladas = request.data.producao_milho_mil_toneladas;
      this.ddg = request.data.ddg;
      this.oleo = request.data.oleo;
      this.combustivel_usado = request.data.combustivel_usado;
      this.tancagem = request.data.tancagem;
      this.biogasBiometano = request.data.biogasBiometano;
      this.graficoCentroGravidade = request.data.graficoCentroGravidade;

      //exame_vendas_liquidas
      if(request.data.exame_vendas_liquidas){
        const vendas_liquidas = JSON.parse(request.data.exame_vendas_liquidas);
        Object.keys(vendas_liquidas).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: vendas_liquidas[key]
          }
          this.exame_vendas_liquidas.push(arrayVendas);
        });
      }

      //exame_crescimento_vendas
      if(request.data.exame_crescimento_vendas){
        const crescimento_vendas = JSON.parse(request.data.exame_crescimento_vendas);
        Object.keys(crescimento_vendas).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: crescimento_vendas[key]
          }
          this.exame_crescimento_vendas.push(arrayVendas);
        });
      }

      //exame_lucro_liquido_ajustado
      if(request.data.exame_lucro_liquido_ajustado){
        const lucro_liquido_ajustado = JSON.parse(request.data.exame_lucro_liquido_ajustado);
        Object.keys(lucro_liquido_ajustado).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: lucro_liquido_ajustado[key]
          }
          this.exame_lucro_liquido_ajustado.push(arrayVendas);
        });
      }

      //exame_lucro_liquido_legal
      if(request.data.exame_lucro_liquido_legal){
        const lucro_liquido_legal = JSON.parse(request.data.exame_lucro_liquido_legal);
        Object.keys(lucro_liquido_legal).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: lucro_liquido_legal[key]
          }
          this.exame_lucro_liquido_legal.push(arrayVendas);
        });
      }

      //exame_patrimonio_liquido_ajustado
      if(request.data.exame_patrimonio_liquido_ajustado){
        const patrimonio_liquido_ajustado = JSON.parse(request.data.exame_patrimonio_liquido_ajustado);
        Object.keys(patrimonio_liquido_ajustado).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: patrimonio_liquido_ajustado[key]
          }
          this.exame_patrimonio_liquido_ajustado.push(arrayVendas);
        });
      }

      //exame_patrimonio_liquido_legal
      if(request.data.exame_patrimonio_liquido_legal){
        const patrimonio_liquido_legal = JSON.parse(request.data.exame_patrimonio_liquido_legal);
        Object.keys(patrimonio_liquido_legal).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: patrimonio_liquido_legal[key]
          }
          this.exame_patrimonio_liquido_legal.push(arrayVendas);
        });
      }

      //exame_rentabilidade_patrimonio_ajustada
      if(request.data.exame_rentabilidade_patrimonio_ajustada){
        const rentabilidade_patrimonio_ajustada = JSON.parse(request.data.exame_rentabilidade_patrimonio_ajustada);
        Object.keys(rentabilidade_patrimonio_ajustada).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: rentabilidade_patrimonio_ajustada[key]
          }
          this.exame_rentabilidade_patrimonio_ajustada.push(arrayVendas);
        });
      }

      //exame_rentabilidade_patrimonio_legal
      if(request.data.exame_rentabilidade_patrimonio_legal){
        const rentabilidade_patrimonio_legal = JSON.parse(request.data.exame_rentabilidade_patrimonio_legal);
        Object.keys(rentabilidade_patrimonio_legal).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: rentabilidade_patrimonio_legal[key]
          }
          this.exame_rentabilidade_patrimonio_legal.push(arrayVendas);
        });
      }

      //exame_capital_circulante_liquido
      if(request.data.exame_capital_circulante_liquido){
        const capital_circulante_liquido = JSON.parse(request.data.exame_capital_circulante_liquido);
        Object.keys(capital_circulante_liquido).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: capital_circulante_liquido[key]
          }
          this.exame_capital_circulante_liquido.push(arrayVendas);
        });
      }

      //exame_liquidez_geral
      if(request.data.exame_liquidez_geral){
        const liquidez_geral = JSON.parse(request.data.exame_liquidez_geral);
        Object.keys(liquidez_geral).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: liquidez_geral[key]
          }
          this.exame_liquidez_geral.push(arrayVendas);
        });
      }

      //exame_endividamento_geral
      if(request.data.exame_endividamento_geral){
        const endividamento_geral = JSON.parse(request.data.exame_endividamento_geral);
        Object.keys(endividamento_geral).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: endividamento_geral[key]
          }
          this.exame_endividamento_geral.push(arrayVendas);
        });
      }

      //exame_endividamento_longo_prazo
      if(request.data.exame_endividamento_longo_prazo){
        const endividamento_longo_prazo = JSON.parse(request.data.exame_endividamento_longo_prazo);
        Object.keys(endividamento_longo_prazo).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: endividamento_longo_prazo[key]
          }
          this.exame_endividamento_longo_prazo.push(arrayVendas);
        });
      }

      //exame_riqueza_criada
      if(request.data.exame_riqueza_criada){
        const riqueza_criada = JSON.parse(request.data.exame_riqueza_criada);
        Object.keys(riqueza_criada).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: riqueza_criada[key]
          }
          this.exame_riqueza_criada.push(arrayVendas);
        });
      }

      //exame_numero_empregados
      if(request.data.exame_numero_empregados){
        const numero_empregados = JSON.parse(request.data.exame_numero_empregados);
        Object.keys(numero_empregados).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: numero_empregados[key]
          }
          this.exame_numero_empregados.push(arrayVendas);
        });
      }

      //exame_riqueza_criada_por_empregado
      if(request.data.exame_riqueza_criada_por_empregado){
        const riqueza_criada_por_empregado = JSON.parse(request.data.exame_riqueza_criada_por_empregado);
        Object.keys(riqueza_criada_por_empregado).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: riqueza_criada_por_empregado[key]
          }
          this.exame_riqueza_criada_por_empregado.push(arrayVendas);
        });
      }

      //exame_ebitda
      if(request.data.exame_ebitda){
        const ebitda = JSON.parse(request.data.exame_ebitda);
        Object.keys(ebitda).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: ebitda[key]
          }
          this.exame_ebitda.push(arrayVendas);
        });
      }

      //exame_salarios_encargos
      if(request.data.exame_salarios_encargos){
        const salarios_encargos = JSON.parse(request.data.exame_salarios_encargos);
        Object.keys(salarios_encargos).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: salarios_encargos[key]
          }
          this.exame_salarios_encargos.push(arrayVendas);
        });
      }

      //exame_tributos
      if(request.data.exame_tributos){
        const tributos = JSON.parse(request.data.exame_tributos);
        Object.keys(tributos).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: tributos[key]
          }
          this.exame_tributos.push(arrayVendas);
        });
      }

      //exame_valor_exportado
      if(request.data.exame_valor_exportado){
        const valor_exportado = JSON.parse(request.data.exame_valor_exportado);
        Object.keys(valor_exportado).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: valor_exportado[key]
          }
          this.exame_valor_exportado.push(arrayVendas);
        });
      }

      //exame_percentual_vendas_exportacao
      if(request.data.exame_percentual_vendas_exportacao){
        const percentual_vendas_exportacao = JSON.parse(request.data.exame_percentual_vendas_exportacao);
        Object.keys(percentual_vendas_exportacao).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: percentual_vendas_exportacao[key]
          }
          this.exame_percentual_vendas_exportacao.push(arrayVendas);
        });
      }

      //exame_maiores_dividendos
      if(request.data.exame_maiores_dividendos){
        const maiores_dividendos = JSON.parse(request.data.exame_maiores_dividendos);
        Object.keys(maiores_dividendos).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: maiores_dividendos[key]
          }
          this.exame_maiores_dividendos.push(arrayVendas);
        });
      }

      //exame_margem_vendas
      if(request.data.exame_margem_vendas){
        const margem_vendas = JSON.parse(request.data.exame_margem_vendas);
        Object.keys(margem_vendas).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: margem_vendas[key]
          }
          this.exame_margem_vendas.push(arrayVendas);
        });
      }

      //exame_giro
      if(request.data.exame_giro){
        const giro = JSON.parse(request.data.exame_giro);
        Object.keys(giro).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: giro[key]
          }
          this.exame_giro.push(arrayVendas);
        });
      }

      //exame_liquidez_corrente
      if(request.data.exame_liquidez_corrente){
        const liquidez_corrente = JSON.parse(request.data.exame_liquidez_corrente);
        Object.keys(liquidez_corrente).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: liquidez_corrente[key]
          }
          this.exame_liquidez_corrente.push(arrayVendas);
        });
      }

      //exame_total_ativo
      if(request.data.exame_total_ativo){
        const total_ativo = JSON.parse(request.data.exame_total_ativo);
        Object.keys(total_ativo).forEach( (key) => {
          const arrayVendas = {
            ano: key,
            valor: total_ativo[key]
          }
          this.exame_total_ativo.push(arrayVendas);
        });
      }
      
      //selos
      if(request.data.selos){
        const selosObj = JSON.parse(request.data.selos);
        Object.keys(selosObj).forEach( async (key) => {
          if(key == "ANP") this.selos_ANP = selosObj[key] ? await this.selos.find(item => item.value === selosObj[key]) : this.selos[0];
          if(key == "ANPCancelado") this.selos_ANPCancelado = selosObj[key] ? await this.selos.find(item => item.value === selosObj[key]) : this.selos[0];
          if(key == "SAPCana") this.selos_SAPCana = selosObj[key] ? await this.selos.find(item => item.value === selosObj[key]) : this.selos[0];
          if(key == "EUA") this.selos_EUA = selosObj[key] ? await this.selos.find(item => item.value === selosObj[key]) : this.selos[0];
          if(key == "California") this.selos_California = selosObj[key] ? await this.selos.find(item => item.value === selosObj[key]) : this.selos[0];
          if(key == "Bonsucro") this.selos_Bonsucro = selosObj[key] ? await this.selos.find(item => item.value === selosObj[key]) : this.selos[0];
          if(key == "CompromissoNacional") this.selos_CompromissoNacional = selosObj[key] ? await this.selos.find(item => item.value === selosObj[key]) : this.selos[0];
          if(key == "EtanolVerde") this.selos_EtanolVerde = selosObj[key] ? await this.selos.find(item => item.value === selosObj[key]) : this.selos[0];
          if(key == "EnergiaVerde") this.selos_EnergiaVerde = selosObj[key] ? await this.selos.find(item => item.value === selosObj[key]) : this.selos[0];
        });
      }

      //cogeracao
      if(request.data.destino_proprietario_cogeracao){
        const cogeracao = JSON.parse(request.data.destino_proprietario_cogeracao);
        Object.keys(cogeracao).forEach( (key) => {

          let empresa = cogeracao[key].valores ? (Object.keys( cogeracao[key].valores )).toString() : '';
          let participacao = cogeracao[key].valores[empresa];
          let obj = {
            destino: cogeracao[key].destino,
            nome: cogeracao[key].nome,
            potencia: cogeracao[key].potencia,
            empresa,
            participacao
          };

          this.destino_proprietario_cogeracao.push(obj);
        });
      }

      //gravidade
      if(request.data.geracao_centro_gravidade){
        const gravidade = JSON.parse(request.data.geracao_centro_gravidade);
        let centroGravidade = {};
        Object.keys(gravidade).forEach( (mes) => {
          Object.keys(gravidade[mes]).forEach( (ano) => {

            //Se não tiver o ano
            if(!centroGravidade[ano]){
              centroGravidade[ano] = {
                ano: ano
              };
            }              
      
            //Se não tiver o mês
            if(!centroGravidade[ano][mes]){
              centroGravidade[ano][mes] = {};
            }
            
            centroGravidade[ano][mes] = gravidade[mes][ano];
          });
        });

        //Passa para array
          Object.keys(centroGravidade).forEach( (key) => {
            this.geracao_centro_gravidade.push(centroGravidade[key]);
          });
      }

      //Exportações
      if(request.data.dados_de_exportacoes){
        const exportacoes = JSON.parse(request.data.dados_de_exportacoes);
        Object.keys(exportacoes).forEach( async (key) => {
          exportacoes[key]['pais'] = await this.paisesName.find(item => item.text == key);
          this.paisesExportacoes.push(key);

          let paises = [];
          let idPaises = 0;
          Object.keys(exportacoes[key].anos).forEach( (keyPaises) => {
            let anos = {
              id: idPaises,
              ano: keyPaises,
              descricao: exportacoes[key].anos[keyPaises].trim()
            }
            paises.push(anos);

            idPaises++;
          });
          exportacoes[key].anos = paises;

          this.dados_de_exportacoes.push(exportacoes[key]);
        });
      }
    })
    .catch(() => {
      this.loading = false;
    });
  }
}
</script>

<style lang="scss">
.vue2leaflet-map{
  &.leaflet-container{
    height: 250px;
  }
}
</style>